import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";

import type { Conversation } from "../types";
import type { GroupOwner } from "./group";

export interface GroupInvitePreview {
  id: number;
  name: string;
  type: "public" | "private";
  image_url: string | null;
  image_thumb: string | null;
  invite_token: string;
  owner: GroupOwner;
  can_join: boolean;
  can_leave: boolean;
  can_update: boolean;
  can_delete: boolean;
  conversation?: Conversation<true, true, true>;
}

export interface JoinGroupResult {
  id: number;
  name: string;
  type: "public" | "private";
  image_url: string | null;
  image_thumb: string | null;
  invite_token: string;
  owner: GroupOwner;
  can_join: boolean;
  can_leave: boolean;
  conversation?: Conversation<true, true, true>;
}

export const groupInvites = createQueryKeys("messenger-group-invites", {
  one: (token?: string) => [token],
});

const inviteInclude = "conversation";

export const fetchGroupInviteQueryOptions = (token?: string) =>
  queryOptions({
    ...groupInvites.one(token),
    queryFn: () =>
      api
        .get<GroupInvitePreview>(`/messenger/groups/token/${token}`, {
          params: { include: inviteInclude },
        })
        .then((response) => response.data),
    enabled: !!token,
  });

export const useFetchGroupInvite = (token?: string) =>
  useQuery(fetchGroupInviteQueryOptions(token));

export const useJoinGroup = () =>
  useMutation({
    mutationFn: (token: string) =>
      api
        .post<JoinGroupResult>(`/messenger/groups/join/${token}`, null, {
          params: { include: inviteInclude },
        })
        .then((response) => response.data),
  });
